import { useEffect, useState, createContext, useContext } from 'react'
import { useParams,useNavigate } from 'react-router-dom'
import { MdCreate } from "react-icons/md";

import { getCategoryWithProjects } from '../../api/category.api';
import ExpandableProjectsComponent from '../../components/Project/ExpandableProjectComponent';
import ToolbarOptionComponent from '../../components/toolbar/ToolbarOptionComponent';
import {ProjectModal} from '../../components/Project/ProjectModal';
import { toolbarActions } from '../../services/EnumsService';

const CategoryContext = createContext();
export const CategoryData = () => useContext(CategoryContext);

export const CategoryWrapper = ()=>{
    const params = useParams();
    const navigate = useNavigate();
    const [category, setCategory] = useState({projects:[]})
    const [showProjectModal, setShowProjectModal] = useState(false)

    async function loadCategoryProjects() {
        if (params.id) {
            const res = await getCategoryWithProjects(params.id)
            setCategory(res.data)
        }
    }

    const addProjectAction = (()=>{
        setShowProjectModal(true)
    })
    const addProjectCloseAction = (()=>{
        setShowProjectModal(false)
    })

    useEffect(() => {
        loadCategoryProjects()
        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params.id]);

    const refreshProjectsCategory = async (category) => {
        await loadCategoryProjects()
    }

    const renderProjects = () => {
        if(category === undefined || category.projects === undefined) return
        const minOrder = Math.min(...category.projects.map(p=>p.order))
        const maxOrder = Math.max(...category.projects.map(p=>p.order))
        return category.projects.map((project) => (
            <ExpandableProjectsComponent key={project.id} project={project} isFirst={project.order === minOrder} isLast={project.order === maxOrder}/>
        ))
    }

    const addProjectModal = (<ProjectModal category={category} closeAction={addProjectCloseAction}></ProjectModal>)
    const handleEdit = (event) => {
        if(event.metaKey || event.ctrlKey) return;
        event.preventDefault();
        navigate(`/category/${category.id}`)
    }

    return(
        <div className='mb-2 rounded-lg'>
            <CategoryContext.Provider value={{category, refreshProjectsCategory}}>
                {showProjectModal && addProjectModal}
                <div className='mt-2 ml-2'>
                    <div className='grid grid-cols-3'>
                        <div className='col-span-3 flex flex-row'>
                            <div className='font-bold text-2xl mb-3'>{category.name}</div>
                            <div className='font-bold text-2xl text-gray-400 text-right ml-2'>(#{category.projects.length})</div>
                            <div className='pt-2'>
                                <ToolbarOptionComponent title={'+ Proyecto'} size={20} icon={toolbarActions.AddTask} clickAction={addProjectAction}/>
                            </div>
                            <div className="ml-4 pt-2 text-right">
                                <a className="" href={`/category/${category.id}`} onClick={handleEdit}><MdCreate/></a>
                            </div>           

                        </div>
                    </div>
                    <div className='w-full pr-2'>
                        {renderProjects()}
                    </div>
                </div>
            </CategoryContext.Provider>
        </div>
    )
}